var Backbone = require('backbone');
var BackboneModelBinder = require('backbone.modelbinder');

var BaseBinderView = Backbone.View.extend(
	{
		initialize: function () {
			this.modelBinder = new BackboneModelBinder();
		},

		remove: function () {
			this.modelBinder.unbind();
			Backbone.View.prototype.remove.apply(this);
			this.trigger('close');
		},

		close: function () {
			this.remove();
		},

		createClassModifierBinding: function (modifier, className) {
			if (className == null) className = this.className;

			var classNameWithModifier = [className, modifier].join('_');

			return {
				selector: '',
				elAttribute: 'class',
				converter: function (dir, value) {
					if (value) value = value.toString().replace(/[ ]/g, '_');
					return [classNameWithModifier, value].join('_');
				}
			}
		},

		createNestedClassModifierBinding: function (selector, className) {
			if (className == null) className = selector.replace(/\./g, '');

			return {
				selector: selector,
				elAttribute: 'class',
				converter: function (dir, value) {
					if (value) value = value.replace(/[ ]/g, '_');
					return [className, value].join('_');
				}
			}
		}
	});

module.exports = BaseBinderView;


// WEBPACK FOOTER //
// ./app/lib/model-binder.js